import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.nk.training');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-nk-training',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.nk.training/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

button,
input {
  outline: none;
}

img {
  user-select: none;
}`],
})
export class PageNkTrainingComponent implements OnInit, OnDestroy {
    public activeTab: string = 'training';
    public pureSplitCards: any[] = [
        { key: 'train', tag: 'TRAIN', title: 'Pure NK train', description: '정상 manifold와 train-only 정규화 파라미터 학습' },
        { key: 'calibration', tag: 'CALIBRATION', title: 'Pure NK calibration', description: '정상 score 분포와 목표 FPR threshold 고정' },
        { key: 'test', tag: 'TEST', title: '별도 Pure NK test', description: '학습 후 최종 specificity 평가 전용' }
    ];
    public datasets: any = {
        train: { count: 0, recent: [] },
        calibration: { count: 0, recent: [] },
        test: { count: 0, recent: [] },
        audit: {
            actual_ratios: { train: 0, calibration: 0, test: 0 },
            group_overlap: [],
            random_seed: 20260902
        }
    };
    public requirements: any = {};
    public model: any = null;
    public challenge: any = null;
    public challengeResults: any[] = [];
    public inferenceResults: any[] = [];
    public selectedInference: any = null;
    public selectedFiles: any[] = [];
    public loading: boolean = true;
    public uploading: boolean = false;
    public training: boolean = false;
    public classifying: boolean = false;
    public analyzing: boolean = false;
    public dragActive: boolean = false;
    public progress: number = 0;
    public progressMessage: string = '';
    public resultFilter: string = 'all';
    public resultSort: string = 'newest';
    public uploadMeta: any = {
        train: { groupId: '', distributionId: '' },
        calibration: { groupId: '', distributionId: '' },
        test: { groupId: '', distributionId: '' }
    };
    public pureUploadReports: any = {
        train: null,
        calibration: null,
        test: null
    };
    public config: any = {
        desiredFprPercent: 1,
        rawComponents: 32,
        physicsComponents: 24,
        trainCnn: true,
        cnnEpochs: 8
    };
    public challengeConfig: any = {
        nanoparticleCount: 1,
        distributionId: '',
        targetSpecificityPercent: 99,
        targetSensitivityPercent: 95
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStatus();
    }

    public ngOnDestroy() {
        this.revokeSelectedFiles();
    }

    public async setTab(tab: string) {
        this.activeTab = tab;
        if (tab === 'minimum' && this.isModelReady()) {
            await this.refreshChallenge();
        }
        if (tab === 'classification' && this.inferenceResults.length > 0 && !this.selectedInference) {
            await this.selectInferenceResult(this.inferenceResults[0]);
        }
        await this.service.render();
    }

    public async loadStatus() {
        this.loading = true;
        await this.service.render();
        const response: any = await wiz.call('status');
        if (response && response.code === 200) {
            this.datasets = response.data.datasets || this.datasets;
            this.requirements = response.data.requirements || {};
            this.model = response.data.model || null;
            this.challenge = response.data.challenge || null;
            this.challengeResults = response.data.recent_results || [];
            this.inferenceResults = response.data.inference_results || [];
            if (this.selectedInference) {
                const currentId = this.selectedInference.id;
                if (!this.inferenceResults.some((item) => item.id === currentId)) {
                    this.selectedInference = null;
                }
            }
        } else {
            await this.service.modal.error(this.errorMessage(response, '현재 상태를 불러오지 못했습니다.'));
        }
        this.loading = false;
        await this.service.render();
    }

    public isModelReady() {
        return Boolean(this.model && this.model.compatible && !this.model.stale);
    }

    public canTrain() {
        return this.datasets.train.count >= (this.requirements.minimum_train || 8)
            && this.datasets.calibration.count >= (this.requirements.minimum_calibration || 4)
            && this.datasets.test.count >= (this.requirements.minimum_test || 4)
            && !(this.datasets.audit.group_overlap || []).length;
    }

    public async selectPureImages(split: string) {
        const files: any = await this.service.file.select({
            accept: 'image/jpeg,image/png,image/tiff,image/bmp,image/webp',
            multiple: true
        });
        await this.uploadPure(split, Array.from(files || []));
    }

    public async selectPureFolder(split: string) {
        const files: any = await this.service.file.select({ type: 'folder' });
        await this.uploadPure(split, Array.from(files || []));
    }

    public async uploadPure(split: string, files: any[]) {
        if (this.uploading) return;
        const acceptedFiles = files.filter((file) => this.isSupportedImage(file));
        const nonImageFiles = files.filter((file) => !this.isSupportedImage(file));
        if (acceptedFiles.length === 0) {
            this.pureUploadReports[split] = {
                selected: files.length,
                imageCandidates: 0,
                nonImageExcluded: nonImageFiles.length,
                added: 0,
                duplicated: 0,
                rejected: 0,
                reasons: [],
                nonImageExamples: nonImageFiles.slice(0, 3).map((file) => file.name)
            };
            await this.service.render();
            if (files.length > 0) {
                await this.service.modal.warning(
                    '선택한 ' + files.length + '개 파일 중 지원되는 이미지가 없습니다. XLSX 등 비이미지 파일은 업로드하지 않습니다.'
                );
            }
            return;
        }
        this.uploading = true;
        this.progress = 0;
        this.progressMessage = (
            this.splitLabel(split) + ' 이미지 ' + acceptedFiles.length + '개 선별'
            + (nonImageFiles.length > 0 ? ' · 비이미지 ' + nonImageFiles.length + '개 제외' : '')
        );
        await this.service.render();

        const batches = this.buildBatches(acceptedFiles, 20, 40 * 1024 * 1024);
        let added = 0;
        let duplicated = 0;
        let rejected: any[] = [];
        for (let index = 0; index < batches.length; index++) {
            const formData = new FormData();
            formData.append('split', split);
            formData.append('group_id', String(this.uploadMeta[split].groupId || ''));
            formData.append('distribution_id', String(this.uploadMeta[split].distributionId || ''));
            for (const file of batches[index]) formData.append('file[]', file);
            const response: any = await this.service.file.upload(
                wiz.url('upload_pure'),
                formData,
                async (percent: number) => {
                    this.progress = Math.round(((index + percent / 100) / batches.length) * 100);
                    this.progressMessage = (
                        '배치 ' + (index + 1) + '/' + batches.length + ' 업로드 중'
                        + ' · 비이미지 ' + nonImageFiles.length + '개 제외'
                    );
                    await this.service.render();
                }
            );
            if (!response || response.code !== 200) {
                this.uploading = false;
                await this.service.render();
                await this.service.modal.error(this.errorMessage(response, 'Pure NK 업로드에 실패했습니다.'));
                return;
            }
            added += (response.data.accepted || []).length;
            duplicated += (response.data.skipped || []).length;
            rejected = rejected.concat(response.data.rejected || []);
        }
        const reasons = this.summarizeRejections(rejected);
        this.pureUploadReports[split] = {
            selected: files.length,
            imageCandidates: acceptedFiles.length,
            nonImageExcluded: nonImageFiles.length,
            added: added,
            duplicated: duplicated,
            rejected: rejected.length,
            reasons: reasons,
            nonImageExamples: nonImageFiles.slice(0, 3).map((file) => file.name)
        };
        this.uploading = false;
        this.progress = 100;
        this.progressMessage = (
            added + '장 등록 · ' + duplicated + '장 중복 · '
            + rejected.length + '장 검증 제외 · ' + nonImageFiles.length + '개 비이미지 제외'
        );
        await this.loadStatus();
        if (rejected.length > 0) {
            const details = reasons.slice(0, 5).map((item) => (
                item.count + '장: ' + item.reason
                + (item.examples.length > 0 ? ' (' + item.examples.join(', ') + ')' : '')
            )).join('\n');
            await this.service.modal.warning(
                this.progressMessage + (details ? '\n\n제외 사유\n' + details : '')
            );
        } else {
            await this.service.modal.success(this.progressMessage);
        }
    }

    public async removePure(item: any) {
        const confirmed = await this.service.modal.show({
            title: 'Pure NK 이미지 제외',
            message: item.name + '을(를) ' + this.splitLabel(item.split) + '에서 제외할까요?',
            action: '제외',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        const response: any = await wiz.call('remove_pure', { split: item.split, id: item.id });
        if (!response || response.code !== 200) {
            await this.service.modal.error(this.errorMessage(response, '이미지를 제외하지 못했습니다.'));
            return;
        }
        await this.loadStatus();
    }

    public async clearPure(split: string) {
        const dataset = this.datasets[split];
        if (!dataset || dataset.count === 0) return;
        const confirmed = await this.service.modal.show({
            title: this.splitLabel(split) + ' 데이터 삭제',
            message: '해당 split의 Pure NK 이미지를 모두 삭제합니다. 기존 모델은 재학습이 필요합니다.',
            action: '전체 삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        const response: any = await wiz.call('clear_pure', { split: split });
        if (!response || response.code !== 200) {
            await this.service.modal.error(this.errorMessage(response, '데이터를 삭제하지 못했습니다.'));
            return;
        }
        await this.loadStatus();
    }

    public async trainModel() {
        if (!this.canTrain() || this.training) return;
        this.training = true;
        await this.service.status.show('loading');
        await this.service.render();
        const response: any = await wiz.call('train_model', {
            desired_fpr: Number(this.config.desiredFprPercent) / 100,
            raw_components: Number(this.config.rawComponents),
            physics_components: Number(this.config.physicsComponents),
            train_cnn: Boolean(this.config.trainCnn),
            cnn_epochs: Number(this.config.cnnEpochs)
        });
        await this.service.status.hide('loading');
        this.training = false;
        if (response && response.code === 200) {
            await this.loadStatus();
            await this.service.modal.success('모델 학습, calibration threshold 고정, Pure NK test 평가를 완료했습니다.');
        } else {
            await this.service.render();
            await this.service.modal.error(this.errorMessage(response, '모델 학습에 실패했습니다.'));
        }
    }

    public async selectSingleInference() {
        const files: any = await this.service.file.select({
            accept: 'image/jpeg,image/png,image/tiff,image/bmp,image/webp',
            multiple: false
        });
        await this.addInferenceFiles(Array.from(files || []));
    }

    public async selectMultipleInference() {
        const files: any = await this.service.file.select({
            accept: 'image/jpeg,image/png,image/tiff,image/bmp,image/webp',
            multiple: true
        });
        await this.addInferenceFiles(Array.from(files || []));
    }

    public async onInferenceDragOver(event: any) {
        event.preventDefault();
        this.dragActive = true;
        await this.service.render();
    }

    public async onInferenceDragLeave(event: any) {
        event.preventDefault();
        this.dragActive = false;
        await this.service.render();
    }

    public async onInferenceDrop(event: any) {
        event.preventDefault();
        this.dragActive = false;
        const files: any = await this.service.file.drop(event);
        await this.addInferenceFiles(Array.from(files || []));
    }

    public async addInferenceFiles(files: any[]) {
        const existing = new Set(this.selectedFiles.map((item) => this.fileKey(item.file)));
        for (const file of files) {
            if (existing.has(this.fileKey(file))) continue;
            const inspected = await this.inspectImage(file);
            this.selectedFiles.push(inspected);
            existing.add(this.fileKey(file));
        }
        await this.service.render();
    }

    public async removeSelectedFile(index: number) {
        const item = this.selectedFiles[index];
        if (item && item.preview) URL.revokeObjectURL(item.preview);
        this.selectedFiles.splice(index, 1);
        await this.service.render();
    }

    public async clearSelectedFiles() {
        this.revokeSelectedFiles();
        this.selectedFiles = [];
        this.progress = 0;
        this.progressMessage = '';
        await this.service.render();
    }

    public async runClassification() {
        if (!this.isModelReady() || this.selectedFiles.length === 0 || this.classifying) return;
        this.classifying = true;
        this.progress = 0;
        this.progressMessage = '판별 업로드 준비 중';
        for (const item of this.selectedFiles) item.resultStatus = 'processing';
        await this.service.render();

        const files = this.selectedFiles.map((item) => item.file);
        const batches = this.buildBatches(files, 12, 30 * 1024 * 1024);
        let created: any[] = [];
        let failed: any[] = [];
        for (let index = 0; index < batches.length; index++) {
            const formData = new FormData();
            for (const file of batches[index]) formData.append('file[]', file);
            const response: any = await this.service.file.upload(
                wiz.url('classify'),
                formData,
                async (percent: number) => {
                    this.progress = Math.round(((index + percent / 100) / batches.length) * 100);
                    this.progressMessage = '배치 ' + (index + 1) + '/' + batches.length + ' 판별 중';
                    await this.service.render();
                }
            );
            if (!response || response.code !== 200) {
                this.classifying = false;
                await this.service.render();
                await this.service.modal.error(this.errorMessage(response, '이미지 판별에 실패했습니다.'));
                return;
            }
            created = created.concat(response.data.results || []);
            failed = failed.concat(response.data.failed || []);
        }

        for (const item of this.selectedFiles) {
            const success = created.find((row) => row.name === item.name);
            const failure = failed.find((row) => row.name === item.name);
            item.resultStatus = success ? 'success' : 'failed';
            item.reason = failure ? failure.reason : null;
        }
        this.classifying = false;
        this.progress = 100;
        this.progressMessage = created.length + '장 판별 완료 · ' + failed.length + '장 판별 불가';
        await this.loadStatus();
        if (created.length > 0) await this.selectInferenceResult(created[0]);
        await this.service.render();
    }

    public filteredInferenceResults() {
        let rows = this.inferenceResults.filter((item) => {
            if (this.resultFilter === 'all') return true;
            if (this.resultFilter === 'failed') return item.status === 'failed';
            return item.status === 'success' && item.verdict === this.resultFilter;
        });
        rows = rows.slice();
        if (this.resultSort === 'score_desc') {
            rows.sort((a, b) => Number(b.total_anomaly_score || -1) - Number(a.total_anomaly_score || -1));
        } else if (this.resultSort === 'score_asc') {
            rows.sort((a, b) => Number(a.total_anomaly_score || 999999) - Number(b.total_anomaly_score || 999999));
        } else if (this.resultSort === 'name') {
            rows.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')));
        } else {
            rows.sort((a, b) => String(b.analyzed_at || '').localeCompare(String(a.analyzed_at || '')));
        }
        return rows;
    }

    public async selectInferenceResult(item: any) {
        if (!item) return;
        if (item.status === 'failed') {
            this.selectedInference = item;
            await this.service.render();
            return;
        }
        const response: any = await wiz.call('classification_detail', { id: item.id });
        if (response && response.code === 200) {
            this.selectedInference = response.data.result;
        } else {
            await this.service.modal.error(this.errorMessage(response, '상세 결과를 불러오지 못했습니다.'));
        }
        await this.service.render();
    }

    public async clearClassifications() {
        if (this.inferenceResults.length === 0) return;
        const confirmed = await this.service.modal.show({
            title: '현재 모델의 판별 결과 삭제',
            message: '수치 결과와 저장된 원본·복원·잔차·radial 이미지를 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        const response: any = await wiz.call('clear_classifications');
        if (!response || response.code !== 200) {
            await this.service.modal.error(this.errorMessage(response, '판별 결과를 삭제하지 못했습니다.'));
            return;
        }
        this.selectedInference = null;
        await this.loadStatus();
    }

    public async exportResults(kind: string, format: string) {
        const endpoint = kind === 'classification' ? 'classification_export' : 'challenge_export';
        const response: any = await wiz.call(endpoint);
        if (!response || response.code !== 200) {
            await this.service.modal.error(this.errorMessage(response, '결과를 내보내지 못했습니다.'));
            return;
        }
        if (format === 'csv') {
            this.downloadDataUrl(response.data.exports.csv_data_url, response.data.exports.csv_file_name);
        } else {
            this.downloadDataUrl(response.data.exports.json_data_url, response.data.exports.json_file_name);
        }
        await this.service.render();
    }

    public async selectChallengeImages() {
        if (!this.isModelReady() || this.analyzing) return;
        const files: any = await this.service.file.select({
            accept: 'image/jpeg,image/png,image/tiff,image/bmp,image/webp',
            multiple: true
        });
        await this.analyzeChallenge(Array.from(files || []));
    }

    public async selectChallengeFolder() {
        if (!this.isModelReady() || this.analyzing) return;
        const files: any = await this.service.file.select({ type: 'folder' });
        await this.analyzeChallenge(Array.from(files || []));
    }

    public async analyzeChallenge(files: any[]) {
        const acceptedFiles = files.filter((file) => this.isSupportedImage(file));
        if (acceptedFiles.length === 0 || this.analyzing) return;
        this.analyzing = true;
        await this.service.status.show('loading');
        await this.service.render();
        const batches = this.buildBatches(acceptedFiles, 12, 30 * 1024 * 1024);
        let created = 0;
        let failed = 0;
        for (const batch of batches) {
            const formData = new FormData();
            formData.append('nanoparticle_count', String(Math.max(1, Number(this.challengeConfig.nanoparticleCount) || 1)));
            formData.append('distribution_id', String(this.challengeConfig.distributionId || ''));
            for (const file of batch) formData.append('file[]', file);
            const response: any = await this.service.file.upload(wiz.url('analyze'), formData);
            if (!response || response.code !== 200) {
                await this.service.status.hide('loading');
                this.analyzing = false;
                await this.service.render();
                await this.service.modal.error(this.errorMessage(response, 'Minimum Loading 분석에 실패했습니다.'));
                return;
            }
            created += (response.data.results || []).length;
            failed += (response.data.rejected || []).length;
        }
        await this.service.status.hide('loading');
        this.analyzing = false;
        await this.loadStatus();
        await this.refreshChallenge();
        if (failed > 0) {
            await this.service.modal.warning(created + '장 평가 · ' + failed + '장 판별 불가');
        } else {
            await this.service.modal.success(created + '장의 NP-NK 평가를 완료했습니다.');
        }
    }

    public async refreshChallenge() {
        if (!this.isModelReady()) return;
        const response: any = await wiz.call('challenge_summary', {
            target_specificity: Number(this.challengeConfig.targetSpecificityPercent) / 100,
            target_sensitivity: Number(this.challengeConfig.targetSensitivityPercent) / 100
        });
        if (response && response.code === 200) {
            this.challenge = response.data.summary;
        } else {
            await this.service.modal.error(this.errorMessage(response, 'Minimum Loading 통계를 계산하지 못했습니다.'));
        }
        await this.service.render();
    }

    public async clearChallenge() {
        if (!this.challenge || this.challenge.result_count === 0) return;
        const confirmed = await this.service.modal.show({
            title: '현재 모델의 NP-NK 평가 삭제',
            message: '저장된 challenge 결과와 편차 지도를 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        const response: any = await wiz.call('clear_challenge');
        if (!response || response.code !== 200) {
            await this.service.modal.error(this.errorMessage(response, 'Challenge 결과를 삭제하지 못했습니다.'));
            return;
        }
        await this.loadStatus();
    }

    public splitLabel(split: string) {
        if (split === 'train') return '학습';
        if (split === 'calibration') return 'Calibration';
        return 'Pure NK test';
    }

    public recommendedCount(split: string) {
        if (split === 'train') return this.requirements.recommended_train || 500;
        if (split === 'calibration') return this.requirements.recommended_calibration || 1000;
        return this.requirements.recommended_test || 100;
    }

    public verdictLabel(item: any) {
        if (!item || item.status === 'failed' || item.verdict === 'unavailable') return '판별 불가';
        return item.verdict === 'anomaly'
            ? '정상 패턴 범위 이탈 — anomaly'
            : 'Pure NK 정상 패턴 범위 내';
    }

    public resultClass(item: any) {
        if (!item || item.status === 'failed') return 'border-amber-200 bg-amber-50 text-amber-800';
        if (item.verdict === 'anomaly') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-emerald-200 bg-emerald-50 text-emerald-700';
    }

    public minimumLabel() {
        if (!this.challenge || this.challenge.minimum_status === 'calculation_unavailable') return '계산 불가';
        if (this.challenge.minimum_status === 'not_reached') return '미도달';
        return String(this.challenge.minimum_detectable_nanoparticle_loading) + ' NP / cell';
    }

    public formatPercent(value: any, digits: number = 1) {
        if (value === null || value === undefined) return '—';
        return (Number(value) * 100).toFixed(digits) + '%';
    }

    public formatScore(value: any, digits: number = 3) {
        if (value === null || value === undefined) return '사용 불가';
        return Number(value).toFixed(digits);
    }

    public formatCi(value: any) {
        if (!value || value.length !== 2) return '—';
        return this.formatPercent(value[0]) + '–' + this.formatPercent(value[1]);
    }

    public formatBytes(bytes: number) {
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
        return (bytes / Math.pow(1024, index)).toFixed(index === 0 ? 0 : 1) + ' ' + units[index];
    }

    public downloadArtifact(url: string, name: string) {
        if (!url) return;
        this.downloadDataUrl(url, name);
    }

    public trackById(index: number, item: any) {
        return item.id || index;
    }

    private async inspectImage(file: any) {
        const preview = URL.createObjectURL(file);
        const result: any = {
            file: file,
            name: file.name,
            bytes: file.size,
            preview: preview,
            width: null,
            height: null,
            inspection: 'checking',
            resultStatus: 'pending',
            reason: null
        };
        if (!this.isSupportedImage(file)) {
            result.inspection = 'invalid';
            result.reason = '지원되는 이미지 형식이 아닙니다.';
            return result;
        }
        await new Promise<void>((resolve) => {
            const image = new Image();
            image.onload = () => {
                result.width = image.naturalWidth;
                result.height = image.naturalHeight;
                result.inspection = image.naturalWidth === 50 && image.naturalHeight === 50 ? 'ready' : 'invalid';
                if (result.inspection === 'invalid') {
                    result.reason = '규격 오류: ' + image.naturalWidth + '×' + image.naturalHeight + 'px';
                }
                resolve();
            };
            image.onerror = () => {
                result.inspection = 'invalid';
                result.reason = '이미지를 읽을 수 없습니다.';
                resolve();
            };
            image.src = preview;
        });
        return result;
    }

    private downloadDataUrl(url: string, name: string) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = name;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    private revokeSelectedFiles() {
        for (const item of this.selectedFiles) {
            if (item.preview) URL.revokeObjectURL(item.preview);
        }
    }

    private buildBatches(files: any[], maxFiles: number, maxBytes: number) {
        const result: any[][] = [];
        let current: any[] = [];
        let bytes = 0;
        for (const file of files) {
            const size = Number(file.size || 0);
            if (current.length > 0 && (current.length >= maxFiles || bytes + size > maxBytes)) {
                result.push(current);
                current = [];
                bytes = 0;
            }
            current.push(file);
            bytes += size;
        }
        if (current.length > 0) result.push(current);
        return result;
    }

    private isSupportedImage(file: any) {
        if ((file.type || '').indexOf('image/') === 0) return true;
        return /\.(jpe?g|png|tiff?|bmp|webp)$/i.test(file.name || '');
    }

    private summarizeRejections(items: any[]) {
        const grouped: any = {};
        for (const item of items || []) {
            const reason = String(item.reason || '알 수 없는 검증 오류');
            if (!grouped[reason]) grouped[reason] = { reason: reason, count: 0, examples: [] };
            grouped[reason].count += 1;
            if (grouped[reason].examples.length < 3 && item.name) {
                grouped[reason].examples.push(String(item.name));
            }
        }
        return Object.keys(grouped)
            .map((key) => grouped[key])
            .sort((left, right) => right.count - left.count);
    }

    private fileKey(file: any) {
        return [file.name, file.size, file.lastModified].join(':');
    }

    private errorMessage(response: any, fallback: string) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.responseJSON && response.responseJSON.data) {
            return response.responseJSON.data.message || fallback;
        }
        return fallback;
    }
}

export default PageNkTrainingComponent;